import type { RowData } from '@tanstack/react-table';
import type { TableColumn } from '../../tableFeatures';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import React, { MouseEvent, useState } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { monthDayYearDateFormat } from '@efacity/common';
import { textFieldSizes } from './styles';

export const DateColumnFilter = <TableData extends RowData>({ column }: { column: TableColumn<TableData> }) => {
  const defaultValue = (column.getFilterValue() as Date) ?? null;
  const [tempValue, setTempValue] = useState<Date | null>(defaultValue);
  const [open, setOpen] = useState(false);

  const handleFilterAccepted = (newFilterValue: Date | null) => {
    column.setFilterValue(newFilterValue);
  };

  const handleClearDate = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setTempValue(null);
    column.setFilterValue(null);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MobileDatePicker
        open={open}
        onClose={() => setOpen(false)}
        value={tempValue}
        onChange={setTempValue}
        format={monthDayYearDateFormat}
        onAccept={handleFilterAccepted}
        slotProps={{
          textField: {
            variant: 'outlined',
            onClick: () => setOpen(true),
            size: 'small',
            style: { fontSize: '14px', backgroundColor: 'white' },
            InputProps: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton aria-label="clear date" size="small" onClick={handleClearDate} edge="end">
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
              sx: textFieldSizes
            }
          }
        }}
      />
    </LocalizationProvider>
  );
};
